import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import useUserIp from "hooks/useUserIp";

const useCheckBookAvailability = (bookId, options = {}) => {
	const { accessToken } = useTokenStore();
	const { userIp } = useUserIp();

	const checkBookAvailability = async () => {
		const instance = await InitApi({ accessToken, userIp });
		const response = await instance.get(`/books/${bookId}/availability`);
		return response.data;
	};

	return useQuery(["book_availability", bookId, userIp], checkBookAvailability, {
		enabled: !!bookId && !!userIp,
		staleTime: 5 * 60 * 1000, // 5 minutes
		cacheTime: 10 * 60 * 1000, // 10 minutes
		retry: false,
		...options,
	});
};

export default useCheckBookAvailability;
